import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/Login';
import MainLayout from './layouts/MainLayout';
import DashboardPage from './pages/Dashboard';
import ImagesPage from './pages/Images';
import VideosPage from './pages/Videos';
import SfxPage from './pages/Sfx';
import BgmPage from './pages/Bgm';
import ClientsPage from './pages/Clients';
import NotFoundPage from './pages/NotFound';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="images" element={<ImagesPage />} />
            <Route path="videos" element={<VideosPage />} />
            <Route path="sfx" element={<SfxPage />} />
            <Route path="bgm" element={<BgmPage />} />
            <Route path="clients" element={<ClientsPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
